import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

interface Props {
    onClickHarGjeld: (valg: ValgtWeb) => void;
}

const GjeldValg: FC<Props> = ({ onClickHarGjeld }) => {
    const { gjeld, button, validationMessage } = useTranslation();
    const {
        control,
        setValue,
        formState: { errors },
    } = useFormContext<GjeldFormData>();

    const onChangeHarGjeld = (value: ValgtWeb) => {
        setValue('harGjeld', value, { shouldValidate: true });
        onClickHarGjeld(value);
    };

    return (
        <Controller
            name="harGjeld"
            control={control}
            rules={{
                validate: {
                    ikkeValgtHarGjeld: (value: ValgtWeb) => value !== ValgtWeb.IKKE_VALGT,
                },
            }}
            render={({ field: { value } }) => (
                <ButtonToggles
                    label={gjeld.toggelsHarGjeld}
                    data-track-id="kreditt-boliglaan-gjeld-har-annen-gjeld"
                    data-track-linkname={value}
                    onChange={(value) => onChangeHarGjeld(value as ValgtWeb)}
                    selectedOption={value}
                    options={[
                        { label: button.ja, value: ValgtWeb.JA },
                        { label: button.nei, value: ValgtWeb.NEI },
                    ]}
                    errorMessage={
                        errors.harGjeld?.type === 'ikkeValgtHarGjeld' ? `${validationMessage.requiredChoose}` : ''
                    }
                />
            )}
        />
    );
};

export default GjeldValg;
